import { FirstDoorContent } from 'shared/components/FirstDoorContent';
import { FIRST_GIFT_DOOR_LINK } from 'shared/constants/links';
import { useDoorContent } from 'shared/hooks';
import { EAdventDoorsHashs, TDoor } from 'shared/types/doors';

export const FirstDoorContentContainer: React.FC<Omit<TDoor, 'onClickBtn'>> = props => {
  const { handleClickBtn } = useDoorContent({
    doorCode: EAdventDoorsHashs.FirstDoor,
    giftLink: FIRST_GIFT_DOOR_LINK,
  });

  return <FirstDoorContent onClickBtn={handleClickBtn} {...props} />;
};
